import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './components/basic/style.css';
ReactDOM.render(
    <>
    <App />
    </>
    ,document.getElementById('root')
);